<sb-modal-template [templateId]="templateId">
  <div modal-header>
    <sb-button classes="btn-primary" (click)="goBack()" *ngIf="canGoBack()">
      <sb-icon icon="chevronLeft" class="icon-in-btn"></sb-icon>
    </sb-button>
    <sb-icon *ngIf="options.icon" [icon]="options.icon"></sb-icon>
    {{options.title ? (options.title | translate) : '' }}
  </div>
  <div modal-body>
    <div #themodalnav></div>
  </div>
</sb-modal-template>
